import React, {Fragment, useContext, useEffect, useState} from "react";

//css import
import styles from "./CommunityRightMenu.module.css";

//lib import
import {useTranslation} from "react-i18next";
import socket from "socket.io-client";
import useFetch, {CachePolicies} from "use-http";
import moment from "moment";
import {CommunityContext} from "src/pages/context/Community.context";
import {pathRoutes} from "../../../props/util.props";
import {useNavigate} from "react-router-dom";

//components import

const serverUrl: any = window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE;

const CommunityRightMenu = (props: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const communityCtx: any = useContext(CommunityContext);
  const [newMessage, setNewMessage] = useState("");
  const [currentUserId, setCurrentUserId] = useState<string>("");
  const [userFullName, setUserFullName] = useState("");
  const [userImageProfile, setUserImageProfile] = useState("");
  const [messageTime, setMessageTime] = useState("");

  const myLastMessages = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE, {
    method: "post",
    cachePolicy: CachePolicies.NO_CACHE,
  });

  const renderMessageContent = (msg: any) => {
    let messageType = msg?.messageType;
    console.log("msg user",msg);
    
    let result = "";
    if (messageType === "text") {
      result = msg?.messageText;
    } else if (messageType === "sticker") {
      result = `${t("send a sticker")}`;
    } else if (messageType === "image") {
      result = `${t("send a photo")}`;
    } else if (messageType === "video") {
      result = `${t("send a video")}`;
    } else if (messageType === "chat_sound") {
      result = `${t("send a voice message")}`;
    } else if (messageType === "center_file") {
      result = `${t("send a file")}`;
    } else if (messageType === "join_group") {
      result = `${t("joined the group")}`;
    } else if (messageType === "check_in") {
      result = `${t("check in")}`;
    } else if (messageType === "invited_group") {
      result = `${t("invited group")}`;
    } else if (messageType === "kick_group") {
      result = `${t("remove user")}`;
    }
    return result;
  };

  const getMemberInfo = (userID: string, members: any) => {
    return members.find((member: any) => {
      return member?.userID === userID;
    });
  };

  const getUserFullName = (user: any) => {
    console.log("user ==> :: user",user);
    return `${user?.user?.firstname} ${user?.user?.lastname || ""}`;
  };

  const getUserImageProfile = (userImage: any) => {
    return `${userImage?.user?.imageProfileURL}`;
  }

  const getMessageTime = (time: any) => {
    return `${time?.messageTime}`;
  }
  const getLastMessage = async () => {
    const topMsg = await myLastMessages.post("/api/find/messageTop", {
      groupIds: [props.groupID],
    });
    
    let lastMsg = topMsg?.objData?.[props.groupID]?.lastMessage;
    console.log("lastMsg : ", lastMsg);

    const user = getMemberInfo(lastMsg?.userId, props.members);
    if (!user) {
      props?.onLoadUser();
    }
    const fullName = getUserFullName(user);
    const imageProfile = getUserImageProfile(user);
    const messageTime = getMessageTime(lastMsg);
    const text = renderMessageContent(lastMsg);
    
    setNewMessage((prev: any) => {
      return text;
    });

    setUserFullName((prev: any) => {
      return fullName;
    });

    setUserImageProfile((prev: any) => {
      return imageProfile;
    });

    setMessageTime((prev: any) => {
      return messageTime;
    });
  };

  const handleNewMessage = (message: any) => {
    console.log("message 55 : ", message);
    
    const msgObj = message?.objData[0];
    const text = renderMessageContent(msgObj);
    const messageTime = getMessageTime(msgObj);
    const user = getMemberInfo(msgObj?.userId, props.members);
    setCurrentUserId(msgObj?.userId)
    if (!user) {
      props.onLoadUser();
    }
    // const fullName = getUserFullName(user);
    // const imageProfile = getUserImageProfile(user);

    setNewMessage((prev: any) => {
      return text;
    });
    //
    // setUserFullName((prev: any) => {
    //   return fullName;
    // });
    //
    // setUserImageProfile((prev: any) => {
    //   return imageProfile;
    // });

    setMessageTime((prev: any) => {
      return messageTime;
    });
  };

  useEffect(() => {
    if (!props.members) return;
    if (!currentUserId) return;
    const user = getMemberInfo(currentUserId, props.members);
    const fullName = getUserFullName(user);
    const imageProfile = getUserImageProfile(user);

    setUserFullName((prev: any) => {
      return fullName;
    });

    setUserImageProfile((prev: any) => {
      return imageProfile;
    });
  }, [props.members, currentUserId])

  const dateTime = (pTime: any) => {
    console.log("user time",pTime);
    
    if ( props.lang === "th" ) {
      return moment(pTime).format("HH:mm น.")
    } else {
      return moment(pTime).format("LT")
    }
  }

  const handleSelectMenu = (content: string) => {
    // communityCtx.setContent(content);
    navigate(`${pathRoutes.groupCommunity}/${props.groupID}/chat`);
  };

  useEffect(() => {
    let mounted = true;
    let client: any = null;

    const connectSocket = () => {
      let serverUrlTemp = serverUrl;
      let serverUrlPath: any = "";
      let path: any = window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE_CONTEXT;
      if (serverUrlTemp.indexOf(path) != -1) {
        serverUrlTemp = serverUrl.replace(
          window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE_CONTEXT,
          ""
        );
        serverUrlPath = window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE_CONTEXT;
      }
      client = socket.connect(serverUrlTemp, {
        path: serverUrlPath + "/socket.io",
        forceNew: true,
      });

      if (props.groupID) {
        client.on("connect", () => {
          getLastMessage();
          console.log("[Chat] Socket Connected.");
          client.on("messageForGroup_" + props.groupID, (newMessage: any) => {
            handleNewMessage(newMessage);
            console.log("[Chat] Socket New message");
            console.log("[Chat] Socket data : ", newMessage);
          });
        });

        client.on("connect_error", (error: any) => {
          console.warn("[Chat Error] Client connection error!!");
          console.error("[Chat Error] Error message : ", error);
        });
      }
    };

    if (mounted) connectSocket();

    return () => {
      client.disconnect();
      console.log("[Chat] client.disconnect()");
    };
  }, []);

  return (
    <div className={styles.RightMenu}>
      {/* <div className={styles.searchBox}>
        <SearchOutlined className={styles.searchIcon} />
        <input
          type="text"
          placeholder={t("Search")}
          className={styles.searchInput}
        />
      </div>
      <div className={styles.liveLabel}>
        <div>{t("Live")}</div>
        <div
          style={{ color: "#428DFF", fontSize: "0.9rem", cursor: "pointer" }}
        >
          {t("View all")}
        </div>
      </div>
      <LiveContainer /> */}
      <div className={styles.textMessage}>{t("Message")}</div>
      <div className={styles.messageBox}>
        {newMessage && userFullName ? (
          <Fragment>
            <div className={styles.profileImg} style={{
              backgroundImage: `url(${userImageProfile})`
            }}/>

              <div className={styles.detail}>
              <div className={styles.message}>{newMessage}</div>
              <div className={styles.userName}>{userFullName}</div>
            </div>
          </Fragment>
        ) : (
          <div style={{ width: "100%", display: "flex", justifyContent: "center", justifyItems: "center"}}>
            {/*<div className={styles.profileImg} />*/}
            <div className={styles.letStartMsg}>{t("Let's start a chat room")}</div>
          </div>
        )}

        {dateTime(messageTime) !== "Invalid date" ?
          < div className={styles.time}>
            {dateTime(messageTime)}
          </div>
          : null
        }
      </div>
      <div className={styles.textLinkChatroom}
        onClick={() => handleSelectMenu("chat")}
      >
        {t("Go to chat room")}
      </div>
    </div>
  );
};

export default CommunityRightMenu;
